export default __webpack_public_path__ + "static/media/circBack.acb10765.svg";